var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBaBosniaandHerzegovina(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_7656)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.9971 0H0.00292969V45H59.9971V0Z",
    fill: "#000099"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5342 0L2.62207 45.0264V0.0263672L47.5342 0Z",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8369 42.3193L16.2891 40.5352L18.8027 42.3106L17.8535 39.3926L20.332 37.5908H17.2559L16.3066 34.6729L15.3662 37.5996H12.29L14.751 39.4189L13.8369 42.3193ZM6.69141 43.2334L9.76758 43.2246L10.708 40.2979L11.6572 43.2158H14.7334L12.2549 45.0176L13.2041 47.9356L10.6904 46.1602L8.22949 47.9443L9.15234 45.0439L6.69141 43.2334ZM20.3672 33.8115L17.9062 31.9922L20.9824 31.9834L21.9229 29.0654L22.8721 31.9834L25.9482 31.9746L23.4697 33.7764L24.4189 36.7031L21.9053 34.9189L19.4443 36.7119L20.3672 33.8115ZM26.0186 28.1426L23.5576 26.332L26.6338 26.3232L27.5742 23.3965L28.5322 26.3145H31.5996L29.1211 28.1162L30.0703 31.0342L27.5566 29.2588L25.1045 31.043L26.0186 28.1426ZM31.6172 22.5527L29.1562 20.7334H32.2324L33.1641 17.7979L34.1133 20.7158H37.1895L34.7109 22.5088L35.6602 25.4356L33.1465 23.6514L30.6855 25.4443L31.6084 22.5439L31.6172 22.5527ZM37.2773 16.9014L34.8164 15.0908L37.8926 15.082L38.833 12.1553L39.791 15.0732H42.8584L40.3711 16.875L41.3203 19.793L38.8066 18.0176L36.3545 19.8018L37.2686 16.9014H37.2773ZM42.8672 11.2852L40.415 9.46582H43.4912L44.4229 6.53027L45.3809 9.45703H48.457L45.9609 11.25L46.9189 14.168L44.4053 12.3926L41.9619 14.1855L42.8672 11.2852ZM48.4922 5.66016L46.04 3.84082H49.1162L50.0479 0.905273L51.0059 3.83203H54.082L51.5859 5.625L52.5527 8.55176L50.0303 6.76758L47.5869 8.56055L48.4922 5.66016ZM54.1172 0.0351567L51.6738 -1.78418H54.75L55.6904 -4.71094L56.6309 -1.79297H59.707L57.2197 0L58.1689 2.91797L55.6553 1.14258L53.2119 2.93555L54.1172 0.0351567Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_7656"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaBosniaandHerzegovina);
export default __webpack_public_path__ + "static/media/ba Bosnia and Herzegovina.1dc70f958067d71357fbff24f35551a0.svg";
export { ForwardRef as ReactComponent };